import { Component } from '../base/component';
import { ensureElement } from '../../utils/utils';
export class Modal extends Component {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._closeButton = ensureElement('.modal__close', container);
        this._view = ensureElement('.modal__content', container);
        this.container.addEventListener('click', this.close.bind(this));
        this._closeButton.addEventListener('click', this.close.bind(this));
        this._view.addEventListener('click', (e) => e.stopPropagation());
    }
    set view(data) {
        this._view.replaceChildren(data);
    }
    open() {
        this.events.emit('modal:open');
        this.container.classList.add('modal_active');
    }
    close() {
        this.events.emit('modal:close');
        this.container.classList.remove('modal_active');
    }
    render(data) {
        super.render(data);
        this.open();
        return this.container;
    }
}
